<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<div class="d-flex flex-grow align-items-center justify-content-between">
  <h5>{{ 'account.payout.title' | transloco }}</h5>
  @if (toggleTile) {
    <web-design-system-list-toggle (click)="showMe = !showMe" [isCollapsed]="!showMe" />
  }
</div>
<web-design-system-divider />
@if (showMe) {
  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <div class="row mb-2">
          <h5>{{ 'account.payout.clearing-account' | transloco }}</h5>
        </div>
        @if (customerStateFacade.customerAccountData$ | async; as customerAccount) {
          <div class="row justify-content-between">
            <div>{{ 'account.payout.account-num' | transloco }}</div>
            <div>
              {{ customerAccount?.accountNr }}
            </div>
          </div>
          <div class="row justify-content-between">
            <div>
              {{ 'account.payout.balance-from' | transloco }}
              {{ customerAccount?.lastSaldoImportDate | date: 'shortDate' }}
            </div>
            <div>
              {{ customerAccount?.lastImportedSaldo | currency: 'EUR' : 'symbol' }}
            </div>
          </div>
          <div class="row justify-content-between">
            <div>
              {{ 'account.payout.blocked' | transloco }}
              <div class="icon-tooltip-wrapper">
                <svg class="icon icon-14 cursor-pointer" (click)="toolTipShow = !toolTipShow">
                  <use xlink:href="/assets/img/svgs/svgset.svg#info" />
                </svg>
                @if (toolTipShow) {
                  <div class="icon-tooltip-content text-left icon-tooltip-content--show autoheight">
                    <div class="icon-tooltip-close" (click)="toolTipShow = !toolTipShow">
                      <svg class="icon icon-14">
                        <use xlink:href="/assets/img/svgs/svgset.svg#close" />
                      </svg>
                    </div>
                    <div>
                      <p>
                        {{ 'account.payout.blocked-explanation1' | transloco }}
                      </p>
                      <p>{{ 'account.payout.blocked-explanation2' | transloco }}</p>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="text-danger">
              {{ customerAccount?.transferPowerBlocked | currency: 'EUR' : 'symbol' }}
            </div>
          </div>
          <div class="row d-block">
            <web-design-system-divider />
          </div>
          <div class="row justify-content-between">
            <div class="font-bold">{{ 'account.payout.available' | transloco }}</div>
            <div class="font-bold">
              {{ (customerAccount?.transferPower > 0 ? customerAccount.transferPower : 0) | currency: 'EUR' : 'symbol' }}
            </div>
          </div>
          @if (state === 'input') {
            <form (ngSubmit)="proceedToConfirmation(f)" #f="ngForm">
              @if (ongoingRequest) {
                <div class="blockparent"></div>
              }
              <div class="row margin-top-15 justify-content-between">
                <div
                  class="input-group-material margin-top-15"
                  [class.input-group-material--error]="amountInputVar.touched && amountInputVar.invalid"
                >
                  <input
                    type="text"
                    required
                    #amountInputElem
                    data-zid="money-transfer"
                    [zeroPositiveAndInputLowerThan]="customerAccount?.transferPower"
                    [(ngModel)]="mtamountFormatted"
                    name="amountInput"
                    (ngModelChange)="amountChanged()"
                    #amountInputVar="ngModel"
                    [class.empty]="!amountInputVar.value"
                    pattern="^-?\d+(?:\.\d{3})*(?:,\d{0,2})?$"
                    autocomplete="off"
                    id="amountInput"
                  />
                  <div class="input-group-material-icon-state"></div>
                  <label for="amountInput">{{ 'account.payout.payout-amount' | transloco }}</label>
                  @if (amountInputVar.valid) {
                    <div class="input-group-material-message">&nbsp;</div>
                  }
                  @if (amountInputVar.errors && amountInputVar.errors['buttonPressedWithoutAmountEntered']) {
                    <div class="input-group-material-message">{{ 'account.payout.please-enter-amount' | transloco }}</div>
                  }
                  @if (amountInputVar.errors && amountInputVar.errors['pattern']) {
                    <div class="input-group-material-message">{{ 'account.payout.please-correct' | transloco }}</div>
                  }
                  @if (amountInputVar.errors && amountInputVar.errors['inputLowerThan']) {
                    <div class="input-group-material-message">
                      {{
                        'account.payout.warning-max-transfer'
                          | transloco
                            : {
                                amount:
                                  ((customerAccount?.transferPower > 0 ? customerAccount.transferPower : 0) | currency: 'EUR' : 'symbol'),
                              }
                      }}
                    </div>
                  }
                  <web-components-user-notes target="moneytx" />
                </div>
                <div class="d-flex align-items-center justify-content-end mt-2">
                  <web-design-system-button
                    [isSubmit]="true"
                    [disabled]="f.invalid && amountInputVar.touched"
                    size="small"
                    data-zid="money-withdraw"
                  >
                    {{ 'account.payout.payment' | transloco }}
                  </web-design-system-button>
                </div>
              </div>
            </form>
          }
        }
        @if (state === 'confirm' || state === 'success') {
          <div>
            @if (ongoingRequest) {
              <div class="blockparent"></div>
            }
            <div class="row mb-4 mt-3">
              <div class="margin-top-15 border-bottom pl-1">
                @if (state === 'confirm') {
                  <span>{{ 'account.payout.please-check' | transloco }}</span>
                }
                {{ 'account.payout.transfer-details' | transloco }}
              </div>
            </div>
            <div class="row">
              <div class="pl-1">{{ 'account.payout.payment-account' | transloco }}</div>
              @if (customerStateFacade.customerBaseData$ | async; as customerBaseData) {
                <div class="pl-1 pr-2 d-flex flex-wrap">
                  <span>{{ customerBaseData.refAccIban }}&nbsp;</span>
                  <span>{{ '(' + customerBaseData.refAccBank + ')' }}</span>
                </div>
              }
            </div>
            <div class="row justify-content-between">
              <div class="font-bold pl-1">{{ 'account.payout.payment-amount' | transloco }}</div>
              <div class="pl-1 pr-2 font-bold flex-grow text-align-right">
                {{ mtamountFormattedEn | currency: 'EUR' : 'symbol' }}
              </div>
            </div>
          </div>
        }
        @if (state === 'confirm') {
          <div class="row justify-content-center">
            <div class="mt-3">
              <web-components-transaction-auth [payload]="dataToAuthorize" (transactionResult)="authorizedTransactionResult($event)" />
            </div>
          </div>
        }
        @if (state === 'success') {
          <div class="mb-4 mt-3 row flex-column pl-1">
            <div>
              <p>
                {{ 'account.payout.tranfer-recived' | transloco: { hour: (transactionCompletedDate | date: 'mediumTime') } }}
              </p>
            </div>
            <web-design-system-button size="small" (click)="initMt()">{{
              'account.payout.new-transfer' | transloco
            }}</web-design-system-button>
          </div>
        }
        <div class="flex-column mt-3 row">
          <web-components-user-messages />
        </div>
      </div>
    </div>
  </div>
  <web-design-system-divider />
  <div class="col-12 text-size-medium">
    <div class="row mt-2">
      {{ 'account.payout.note' | transloco }}
    </div>
  </div>
}
